import type { FC } from "react";

import {
  HORIZONTAL_CARD_DEFAULTS,
  THorizontalCardProps,
} from "@/ui/components/data-display/Card/Card.config";

import { BaseCard } from "./BaseCard";
import { CardIntroduction } from "./CardIntroduction";
import { CardContent } from "./CardContent";


export const HorizontalCard: FC<THorizontalCardProps> = (
  {
    image,
    title,
    description,
    eyebrow,
    orientation = HORIZONTAL_CARD_DEFAULTS.orientation,
    tags,
    children,
    ...props
  },
) => (
  <BaseCard
    data-component="HorizontalCard"
    image={{ fit: "cover", ...image }}
    ratio="4:3"
    layout="row"
    orientation={orientation}
    tags={tags}
    {...props}
  >
    <CardIntroduction title={title} eyebrow={eyebrow} description={description} />
    <CardContent>
      { children }
    </CardContent>
  </BaseCard>
);

HorizontalCard.displayName = "PreviewCard";
